import { OptOutSortBy, SortDirection } from "src/graphql/generated/globalTypes";

export const OPT_OUT_SORTS = [
  {
    value: { sortBy: OptOutSortBy.CREATED_AT, direction: SortDirection.DESC },
    key: "created_at_desc",
    label: "Added At, Newest First"
  },
  {
    value: { sortBy: OptOutSortBy.CREATED_AT, direction: SortDirection.ASC },
    key: "created_at_asc",
    label: "Added At, Oldest First"
  }
];
